import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import ContentSections from './components/ContentSections';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Sheet',
  url: 'https://sugargoosheet.ink/',
  description: 'The ultimate Sugargoo Spreadsheet resource and shopping intelligence platform. Discover product finds, shipping guides, reviews, coupon codes and expert shopping tips.',
  publisher: {
    '@type': 'Organization',
    name: 'Sugargoo Sheet',
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
    },
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://sugargoosheet.ink/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <CategoryGrid />
      <ArticleCards />
      <ContentSections />
      <Footer />
    </main>
  );
}